import './App.css';
import Editor from './Editor';

function App() {
  return (
    <div className="wrapper">
      <h1>Enter any emojis below</h1>
      <Editor />
    </div>
  );
}

export default App;
